import Vue from 'vue'
import objectToFormData from 'object-to-formdata'

const initialState = {
  list: [],
  spending: {},
  contractors: [],
  loading: false
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    }
  },
  actions: {
    getList({commit}, {params, projectId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/projects/${projectId}/spending/`, {params}).then(response => {
          commit('SET', {key: 'list', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getSpending({commit}, {projectId, spendingId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/projects/${projectId}/spending/${spendingId}/`).then(response => {
          commit('SET', {key: 'spending', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit}, {spending, projectId}) {
      let data = objectToFormData(spending)
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.post(`project_control/projects/${projectId}/spending/`, data, {
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit}, {projectId, spending}) {
      if (!spending.file) {
        delete spending.file
      }
      let data = objectToFormData(spending)
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.patch(`project_control/projects/${projectId}/spending/${spending.id}/`, data, {
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    remove({commit}, {projectId, spendingId}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`project_control/projects/${projectId}/spending/${spendingId}/`).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getRelations ({commit}, projectId) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.get(`project_control/projects/${projectId}/spending/relations/`).then((response) => {
          commit('SET', {key: 'contractors', val: response.data.contractors})
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
